/// <amd-module name="PipelinesUI/LogViewer" />
export { ILogViewerProps, ISection, ISectionLine, ISelection, ISnap } from "./Components/LogViewer/LogViewer.Props";
export { LogViewer } from "./Components/LogViewer/LogViewer";